/**
 * Traduction d'un résultat Google Places en adresse applicative.
 *
 * Extrait de `AddressInput` pour être testable sans DOM ni chargement du SDK
 * Google. Le pays est pris en `short_name`, donc en ISO2.
 */

export interface Address {
  street: string;
  postalCode: string;
  city: string;
  country: string;
}

export const EMPTY_ADDRESS: Address = {
  street: '',
  postalCode: '',
  city: '',
  country: '',
};

interface GoogleAddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

interface GooglePlaceLike {
  address_components?: GoogleAddressComponent[];
}

export const parseGooglePlace = (
  place: GooglePlaceLike | null | undefined,
  limitFrenchCountry = false,
): Address => {
  const components = place?.address_components;
  if (!components || components.length === 0) {
    return { ...EMPTY_ADDRESS };
  }

  let street = '';
  let postalCode = '';
  let city = '';
  let country = '';

  for (const component of components) {
    const { types } = component;

    if (types.includes('street_number')) street += component.long_name + ' ';
    if (types.includes('route')) street += component.short_name;
    if (types.includes('postal_code')) postalCode = component.long_name;
    if (types.includes('locality')) city = component.long_name;
    // Certains pays ne renvoient pas de `locality`.
    if (!city && types.includes('administrative_area_level_2')) {
      city = component.long_name;
    }
    if (types.includes('country')) country = component.short_name;
  }

  // La restriction française garantit le pays même si Google ne le renvoie pas.
  if (!country && limitFrenchCountry) country = 'FR';

  return { street: street.trim(), postalCode, city, country };
};
